import { TextField } from '@mui/material';
import React, { Fragment } from 'react';
import { emptyNotEmpty } from '../attribute-utils';

const FilterContainerInput = (props) => {
  const {
      input,
      t,
      onChangeInput,
      criteria,
      enums,
      inputRange,
      onChangeInputRange,
    } = props || {},
    { Placeholders } = t || {};

  return (
    <Fragment>
      <TextField
        className="smaller-input width-100 background-white"
        size="small"
        label={
          criteria === enums.IN_RANGE.value
            ? Placeholders.from
            : Placeholders.filter
        }
        value={input || ''}
        hidden={emptyNotEmpty(enums, criteria)}
        onChange={onChangeInput}
        InputLabelProps={{ shrink: true }}
      />
      {criteria === enums.IN_RANGE.value && (
        <TextField
          size="small"
          className="smaller-input width-100 background-white in-range"
          label={Placeholders.to}
          value={inputRange || ''}
          onChange={onChangeInputRange}
          InputLabelProps={{ shrink: true }}
        />
      )}
    </Fragment>
  );
};

export default FilterContainerInput;
